<app-header-global></app-header-global>

<div class="row allcontent">
    <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
        <app-side-overlay-menu></app-side-overlay-menu>
    </div>

    <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="card_div">
          <p class="title custom_heading">Memories</p>
        <div class="card_wrapper">
            <div class="row">
                <div class="col-sm-4" *ngFor="let data of memoriesdata" (click)="navigateToSubroute(data.routename)">
                      <div class="image_wrapper">
                        <div class="image_div">
                            <img [src]="data.thumbnail_image" alt="{{data.title}}" srcset=""> 
                         
                        </div>
                        <div class=" title_div">
                            {{data.title}}
                        </div>
                      </div>
                     
                 </div>
               
                </div>
        </div>
          
    </div>
</div>